import {Component} from '@angular/core';
import {FieldType} from '@ngx-formly/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'formly-field-ng-datepicker',
  template: `
    <input type="text"
           class="form-control"
           bsDatepicker
           [formControl]="formControl"
           [formlyAttributes]="field"
           [bsConfig]="{
            isAnimated: true,
            dateInputFormat: to.format ? to.format : 'DD.MM.YYYY',
            containerClass: ['theme-aop']
          }"
    >
  `,
})
// tslint:disable-next-line:component-class-suffix
export class FormlyFieldDatePicker extends FieldType {}
